<template>
    <div>
       <loader :show="enviando"/>
        <v-card>
            <v-card-text>
                <v-autocomplete
                    v-model="dependenciaSel"
                    :items="dependencias"
                    item-text="nombre"
                    item-value="_id"
                    label="Dependencia:"
                    persistent-hint
                    prepend-icon="mdi-city"
                    @change="cargarDependencia()"
                >

                </v-autocomplete>
            </v-card-text>
            <v-card-text>
                <usuarios-dependencia
                    :usuarios="usuarios"
                    :dependencia="dependenciaSel"
                    @horarioIndividualAsignado="horarioIndividualAsignado"
                    @horarioDepAsignado="horarioDepAsignado"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../../components/Loader'
import UsuariosDependencia from './dependencia'

import axios from 'axios'
import moment from 'moment'
export default {
    name: 'Horarios',
	components: {
        Loader,
        UsuariosDependencia
    },
    computed: {
    ...mapGetters([
        "sessionToken",
        "httpURL",
        "userId",
        "tableProps",
        "role",
        "permisos"
      ])
    },
    created(){
        axios.get(this.httpURL+'/horarios/dependencias/listado',{headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                this.dependencias = res.data.dependencias;
                // this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    data() {
        return {
            enviando:false,
            dependencias: [],
            dependenciaSel: null,
            usuarios: []
        }
    },
    methods:{
        cargarDependencia(){
            axios.get(this.httpURL+'/horarios/usuarios/listado/'+this.dependenciaSel,{headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                this.usuarios = res.data.usuarios;
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
        },
        horarioIndividualAsignado(horario,usuario){
            let index = this.usuarios.findIndex(x=>x._id == usuario);
            this.usuarios[index].horario = horario;
        },
        horarioDepAsignado(horario){
            this.usuarios.forEach(element => {
                element.horario = horario;
            });
        }
    }
}
</script>